import('./init').catch(err => console.error(err))
